import { Navigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";

export default function RootRedirect() {
  const { isAuthenticated, status } = useAuth();

  if (status === "booting") return null;

  return isAuthenticated
    ? <Navigate to="/painel" replace />
    : <Navigate to="/login" replace />;
}
